class FrAutocompleteController {
	constructor($templateCache) {
		this.$templateCache = $templateCache;
	}

	$onInit() {
		this.idField = this.idField || "id";
		this.displayField = this.displayField || "name";
		this.listValue = this.listValue || [];
		this.templateItem = this.templateItem || "auto-complete-item-template-default";
		this.searchFileds = this.searchFileds || [this.displayField];
		this.maxItemsToRender = this.maxItemsToRender || 10000;
		this.initOptions();
	}

	initOptions() {
		let _this = this;
		let autoCompleteOptions = {
			minimumChars: _this.minLength ? _this.minLength : 0,
			containerCssClass: 'mt-1',
			selectedTextAttr: _this.displayField,
			data: function () {
				var items = _this.listValue.filter(color => {
					let result = false;
					_this.searchFileds.map(field => {
						if (color[field] && color[field].toString().toLowerCase().includes((_this.searchText) ? _this.searchText.toLowerCase() : ""))
							result = true;
					});
					return result;
				});
				if (_this.sortField)
					items = items.sort((item1, item2) => {
						return item1[_this.sortField] > item2[_this.sortField] ? 1 : (item1[_this.sortField] < item2[_this.sortField] ? -1 : 0);
					});
				if (_this.grouped == "true") {
					let previousGroup = true;
					items = items.map(item => {
						item['previousGroupedValue'] = previousGroup;
						previousGroup = item['groupBy'];
						return item;
					});
				}
				return items;
			},
			itemTemplate: _this.$templateCache.get(_this.templateItem),
			itemSelected: e => {
				_this.onChangeSelection({
					$event: {
						value: e.item
					}
				});
			}
		};
		if (this.activateOnFocus)
			autoCompleteOptions.activateOnFocus = this.activateOnFocus;
		if (this.autoHideDropdown)
			autoCompleteOptions.autoHideDropdown = this.autoHideDropdown;
		if (this.dropdownParent)
			autoCompleteOptions.dropdownParent = $(this.dropdownParent);
		if (this.maxItemsToRender)
			autoCompleteOptions.maxItemsToRender = this.maxItemsToRender;

		this.autoCompleteOptions = autoCompleteOptions;
	}

	/*
     * Clear selectd value
     */
	clearValue() {
		if (!this.searchText)
			this.onClearSelection();
	}
}

export default FrAutocompleteController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/autocomplete/autocomplete.controller.js